import {css} from 'lit';
export const styles = css`:host {
  --gap-sm: 4px;
  --gap-md: 8px;
  --gap-lg: 16px;
  --gap-xl: 32px;

  display: block;
}

:host([col='0']) main {
    display: flex;
    flex-wrap: wrap;
  }

:host([col='1']) main, :host([col='2']) main, :host([col='3']) main, :host([col='4']) main, :host([col='5']) main {
    display: grid;
  }

:host([col='1']) main {
  grid-template-columns: repeat(1, minmax(1px, 1fr));
}

:host([col='2']) main {
  grid-template-columns: repeat(2, minmax(1px, 1fr));
}

:host([col='3']) main {
  grid-template-columns: repeat(3, minmax(1px, 1fr));
}

:host([col='4']) main {
  grid-template-columns: repeat(4, minmax(1px, 1fr));
}

:host([col='5']) main {
  grid-template-columns: repeat(5, minmax(1px, 1fr));
}

@media (min-width: 576px) {
    :host([colxs='0']) main {
      display: flex;
      flex-wrap: wrap;
    }
    :host([colxs='1']) main, :host([colxs='2']) main, :host([colxs='3']) main, :host([colxs='4']) main, :host([colxs='5']) main {
      display: grid;
    }

  :host([colxs='1']) main {
    grid-template-columns: repeat(1, minmax(1px, 1fr));
  }

  :host([colxs='2']) main {
    grid-template-columns: repeat(2, minmax(1px, 1fr));
  }

  :host([colxs='3']) main {
    grid-template-columns: repeat(3, minmax(1px, 1fr));
  }

  :host([colxs='4']) main {
    grid-template-columns: repeat(4, minmax(1px, 1fr));
  }

  :host([colxs='5']) main {
    grid-template-columns: repeat(5, minmax(1px, 1fr));
  }
}

@media (min-width: 768px) {
    :host([colsm='0']) main {
      display: flex;
      flex-wrap: wrap;
    }
    :host([colsm='1']) main, :host([colsm='2']) main, :host([colsm='3']) main, :host([colsm='4']) main, :host([colsm='5']) main {
      display: grid;
    }

  :host([colsm='1']) main {
    grid-template-columns: repeat(1, minmax(1px, 1fr));
  }

  :host([colsm='2']) main {
    grid-template-columns: repeat(2, minmax(1px, 1fr));
  }

  :host([colsm='3']) main {
    grid-template-columns: repeat(3, minmax(1px, 1fr));
  }

  :host([colsm='4']) main {
    grid-template-columns: repeat(4, minmax(1px, 1fr));
  }

  :host([colsm='5']) main {
    grid-template-columns: repeat(5, minmax(1px, 1fr));
  }
}

@media (min-width: 992px) {
    :host([colmd='0']) main {
      display: flex;
      flex-wrap: wrap;
    }
    :host([colmd='1']) main, :host([colmd='2']) main, :host([colmd='3']) main, :host([colmd='4']) main, :host([colmd='5']) main {
      display: grid;
    }

  :host([colmd='1']) main {
    grid-template-columns: repeat(1, minmax(1px, 1fr));
  }

  :host([colmd='2']) main {
    grid-template-columns: repeat(2, minmax(1px, 1fr));
  }

  :host([colmd='3']) main {
    grid-template-columns: repeat(3, minmax(1px, 1fr));
  }

  :host([colmd='4']) main {
    grid-template-columns: repeat(4, minmax(1px, 1fr));
  }

  :host([colmd='5']) main {
    grid-template-columns: repeat(5, minmax(1px, 1fr));
  }
}

@media (min-width: 1200px) {
    :host([collg='0']) main {
      display: flex;
      flex-wrap: wrap;
    }
    :host([collg='1']) main, :host([collg='2']) main, :host([collg='3']) main, :host([collg='4']) main, :host([collg='5']) main {
      display: grid;
    }

  :host([collg='1']) main {
    grid-template-columns: repeat(1, minmax(1px, 1fr));
  }

  :host([collg='2']) main {
    grid-template-columns: repeat(2, minmax(1px, 1fr));
  }

  :host([collg='3']) main {
    grid-template-columns: repeat(3, minmax(1px, 1fr));
  }

  :host([collg='4']) main {
    grid-template-columns: repeat(4, minmax(1px, 1fr));
  }

  :host([collg='5']) main {
    grid-template-columns: repeat(5, minmax(1px, 1fr));
  }
}

:host(:not([col='0'])[gap='small']) main {
  gap: var(--gap-sm);
}

:host(:not([col='0'])[gap='medium']) main {
  gap: var(--gap-md);
}

:host(:not([col='0'])[gap='large']) main {
  gap: var(--gap-lg);
}

:host(:not([col='0'])[gap='extraLarge']) main {
  gap: var(--gap-xl);
}

:host([col='0'][gap='small']) main {
  margin-top: calc(var(--gap-sm) * -1);
  margin-left: calc(var(--gap-sm) * -1);
}

:host([col='0'][gap='medium']) main {
  margin-top: calc(var(--gap-md) * -1);
  margin-left: calc(var(--gap-md) * -1);
}

:host([col='0'][gap='large']) main {
  margin-top: calc(var(--gap-lg) * -1);
  margin-left: calc(var(--gap-lg) * -1);
}

:host([col='0'][gap='extraLarge']) main {
  margin-top: calc(var(--gap-xl) * -1);
  margin-left: calc(var(--gap-xl) * -1);
}

:host([col='0'][gap='small']) slot::slotted(*) {
  margin-top: var(--gap-sm) !important;
  margin-left: var(--gap-sm) !important;
}

:host([col='0'][gap='medium']) slot::slotted(*) {
  margin-top: var(--gap-md) !important;
  margin-left: var(--gap-md) !important;
}

:host([col='0'][gap='large']) slot::slotted(*) {
  margin-top: var(--gap-lg) !important;
  margin-left: var(--gap-lg) !important;
}

:host([col='0'][gap='extraLarge']) slot::slotted(*) {
  margin-top: var(--gap-xl) !important;
  margin-left: var(--gap-xl) !important;
}

:host([alignh='start']) main {
  align-items: flex-start;
}

:host([alignh='center']) main {
  align-items: center;
}

:host([alignh='end']) main {
  align-items: flex-end;
}

:host([alignv='start']) main {
  justify-items: flex-start;
  justify-content: flex-start;
}

:host([alignv='center']) main {
  justify-items: center;
  justify-content: center;
}

:host([alignv='end']) main {
  justify-items: flex-end;
  justify-content: flex-end;
}
`;
export default styles;
